import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { PromoBanner } from "./PromoBanner";
import { MobileBookBar } from "./MobileBookBar";
import { InstallPrompt } from "./InstallPrompt";

const HIDE_BAR_ON = ["/login", "/register", "/checkin", "/dashboard", "/admin"];

export function Layout() {
  const { pathname } = useLocation();
  const [bannerVisible, setBannerVisible] = React.useState(
    () => localStorage.getItem("promo_dismissed") !== "1"
  );

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  const dismissBanner = () => {
    setBannerVisible(false);
    localStorage.setItem("promo_dismissed", "1");
  };

  const showMobileBar = !HIDE_BAR_ON.some((p) => pathname.startsWith(p));

  return (
    <div className="min-h-screen flex flex-col bg-sand">
      <PromoBanner visible={bannerVisible} onClose={dismissBanner} />
      <Navbar bannerVisible={bannerVisible} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* spacer so the fixed mobile bar never covers footer content */}
      {showMobileBar && <div className="h-20 lg:hidden" aria-hidden />}
      <MobileBookBar />
      <InstallPrompt />
    </div>
  );
}
